module.exports = __webpack_public_path__ + "img/TVAPLogo2019Mobile.b2b99c0f.png";